import config from 'styles/config'
import { textSize } from '@portal/kit/pkg/styles'

const { boxMobileMargin } = config.dimensions

export const withRanIcon = () => ({
  position: 'relative',
  paddingLeft: 43,
  ...textSize(14, 19),
})

export const withDesktopRanIcon = () => ({
  paddingTop: 3,
  paddingBottom: 2,
  paddingLeft: 49,
})

export const ranIcon = (theme) => ({
  position: 'absolute',
  left: 0,
  width: 43,
  paddingRight: boxMobileMargin,
  color: theme.main_color,
  fontSize: 20,
  textAlign: 'center',
})

export const desktopRanIcon = () => ({
  width: 49,
  fontSize: 26,
})
